import { createFileRoute } from '@tanstack/react-router';

import { useAppNavigate } from '../../lib/session/navigate';
import { ProfilePage } from '../../portal/profile-page';

/**
 * `/account/profile` — contact details, email settings and sign out (M10.5,
 * FR-PORTAL-05, FR-NOTIF-08).
 *
 * The route owns the navigation, the page owns the screen — the same split every auth
 * screen uses, and what lets the page be tested without a router (PATIENT_AUTH_UI.md §3).
 */
export const Route = createFileRoute('/account/profile')({
  component: ProfileRoute,
});

function ProfileRoute() {
  const navigate = useAppNavigate();

  return (
    <ProfilePage
      onSignedOut={() => {
        navigate('/login', { replace: true });
      }}
    />
  );
}
